import { type FC, useEffect, useRef } from 'react'
import { getIncodeClient } from '@egw/risk-service'
import { Logger } from '@egw/logger'

const log = new Logger('DocV')

interface FaceMatchProps {
  session: { token: string }
  onSuccess: (result: any) => void
  existingUser?: boolean
  liveness?: boolean
  userExists?: boolean
}

export const FaceMatch: FC<FaceMatchProps> = ({ session, onSuccess, liveness, existingUser }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const isMounted = useRef(false)

  useEffect(() => {
    if (isMounted.current || !session || !containerRef.current) {
      return
    }

    log.info('FaceMatch: Starting face match')

    getIncodeClient().renderFaceMatch(containerRef.current, {
      onSuccess,
      token: session,
      liveness,
      existingUser,
      isSecondId: false,
    })

    isMounted.current = true
  }, [onSuccess, session, liveness, existingUser])

  return <div ref={containerRef} />
}
